// // import React, { useState,useEffect} from "react";
// // import profileImg from "../../assets/profile.png";
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import { FaCamera } from "react-icons/fa";
// // import axios from "axios";
// // import {
// //   Eye,
// //   EyeOff,
// // } from "lucide-react";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   showSuccess,
// //   showError,
// // } from "../../General/Toast";



// // const Profile = ({ clientData, setClientData }) => {
// //   const [showCurrentPassword, setShowCurrentPassword] = useState(false);
// // const [showNewPassword, setShowNewPassword] = useState(false);
// // const [showConfirmPassword, setShowConfirmPassword] = useState(false);
// //   const [state, setState] = useState("");
// //   const [signaturePreview, setSignaturePreview] = useState(null);
// //   const [profilePreview, setProfilePreview] = useState(profileImg);
// //   const navigate = useNavigate();
// //   const [passwordData, setPasswordData] = useState({
// //   currentPassword: "",
// //   newPassword: "",
// //   confirmPassword: "",
// // });

// // const [showPasswordSection, setShowPasswordSection] = useState(false);

// // const [profileData, setProfileData] = useState({
// //   business_name: "",
// //   gst: "",
// //   email: "",
// //   mobile: "",
// //   address: "",
// //   state: "",
// //   type: "",
// //   pin: "",
// //   description: "",
// // });

// // const [profileImage, setProfileImage] = useState(null);
// // const [signatureImage, setSignatureImage] = useState(null);
// // const handleProfileChange = (e) => {
// //   const file = e.target.files[0];

// //   if (file) {
// //     setProfileImage(file);
// //     setProfilePreview(URL.createObjectURL(file));
// //   }
// // };
// // const handleChangePassword = async () => {
// //   try {
// //     const userData = JSON.parse(
// //       localStorage.getItem("user_data")
// //     );

// //     if (!passwordData.currentPassword) {
// //       showError("Please enter current password");
// //       return;
// //     }

// //     if (!passwordData.newPassword) {
// //       showError("Please enter new password");
// //       return;
// //     }

// //     if (passwordData.newPassword.length < 6) {
// //       showError("New password must be at least 6 characters");
// //       return;
// //     }

// //     if (
// //       passwordData.newPassword !== passwordData.confirmPassword
// //     ) {
// //       showError("New password and confirm password do not match");
// //       return;
// //     }

// //     const res = await axios.put(
// //       `https://api.dectwinbilling.com/change-password/${userData.id}`,
// //       {
// //         currentPassword: passwordData.currentPassword,
// //         newPassword: passwordData.newPassword,
// //       }
// //     );

// //     showSuccess(
// //       res.data?.message || "Password changed successfully"
// //     );

// //     setPasswordData({
// //       currentPassword: "",
// //       newPassword: "",
// //       confirmPassword: "",
// //     });

// //     setShowPasswordSection(false);

// //   } catch (error) {
// //     console.log(error);

// //     showError(
// //       error.response?.data?.message ||
// //       "Unable to change password"
// //     );
// //   }
// // };
// // const fetchProfile = async () => {
// //   try {
// //     const userData = JSON.parse(
// //       localStorage.getItem("user_data")
// //     );

// //     const res = await axios.get(
// //       `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
// //     );
// //     console.log(res.data,"manageBussiness")

// //     // setProfileData({
// //     //   business_name: res.data.business_name || "",
// //     //   gst: res.data.gst || "",
// //     //   email: res.data.email || "",
// //     //   mobile: res.data.mobile || "",
// //     //   address: res.data.address || "",
// //     //   state: res.data.state || "",
// //     //   type: res.data.type || "",
// //     //   pin: res.data.pin || "",
// //     //   description: res.data.description || "",
// //     // });
// // setProfileData({
// //   business_name: res.data.business_name || "",
// //   gst: res.data.gst || "",
// //   email: res.data.email || "",
// //   mobile: res.data.mobile || "",
// //   address: res.data.address || "",
// //   state: res.data.state || "",
// //   type: res.data.type || "",
// //   pin: res.data.pin || "",
// //   description: res.data.description || "",
// // });

// // setPasswordData({
// //   currentPassword: res.data.pass || "",
// //   newPassword: "",
// //   confirmPassword: "",
// // });
// //     // if (res.data.image) {
// //     //   setProfileImage(
// //     //     `https://api.dectwinbilling.com/dUploads/${res.data.image}`
// //     //   );
// //     // }
// //     if (res.data.image) {
// //   const imageUrl = `https://api.dectwinbilling.com/dUploads/${res.data.image}`;

// //   setProfileImage(imageUrl);
// //   setProfilePreview(imageUrl);
// // }

// //     if (res.data.sign) {
// //       setSignatureImage(
// //         `https://api.dectwinbilling.com/dUploads/${res.data.sign}`
// //       );
// //     }

// //   } catch (error) {
// //     console.log(error);
// //   }
// // };
// // useEffect(() => {
// //   fetchProfile();
// // }, []);

// // const handleSignatureChange = (e) => {
// //   const file = e.target.files[0];

// //   if (file) {
// //     setSignatureImage(file);
// //     setSignaturePreview(URL.createObjectURL(file));
// //   }
// // };
// // const handleSaveProfile = async () => {
// //   try {
// //     const userData = JSON.parse(
// //       localStorage.getItem("user_data")
// //     );

// //     const formData = new FormData();

// //     formData.append(
// //       "business_name",
// //       profileData.business_name
// //     );

// //     formData.append(
// //       "gst",
// //       profileData.gst
// //     );

// //     formData.append(
// //       "email",
// //       profileData.email
// //     );

// //     formData.append(
// //       "address",
// //       profileData.address
// //     );

// //     formData.append(
// //       "state",
// //       profileData.state
// //     );

// //     formData.append(
// //       "type",
// //       profileData.type
// //     );

// //     formData.append(
// //       "pin",
// //       profileData.pin
// //     );

// //     formData.append(
// //       "description",
// //       profileData.description
// //     );

// //     // if (profileImage) {
// //     //   formData.append(
// //     //     "image",
// //     //     profileImage
// //     //   );
// //     // }
// //     if (profileImage instanceof File) {
// //   formData.append("image", profileImage);
// // }

// //     if (signatureImage) {
// //       formData.append(
// //         "sign",
// //         signatureImage
// //       );
// //     }

  
// // const res = await axios.put(
// //   `https://api.dectwinbilling.com/update-profile/${userData.id}`,
// //   formData,
// //   {
// //     headers: {
// //       "Content-Type": "multipart/form-data",
// //     },
// //   }
// // );

// // // const updatedUser = {
// // //   ...userData,
// // //   ...profileData,
// // //   image: res.data.image || userData.image,
// // //   sign: res.data.sign || userData.sign,
// // // };
// // const latestProfile = await axios.get(
// //   `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
// // );

// // const updatedUser = {
// //   ...userData,
// //   ...profileData,
// //   image: latestProfile.data.image || userData.image,
// //   sign: latestProfile.data.sign || userData.sign,
// //   imageUpdatedAt: Date.now(),
// // };

// // localStorage.setItem(
// //   "user_data",
// //   JSON.stringify(updatedUser)
// // );

// // setClientData(updatedUser);

// // showSuccess("Profile Updated Successfully");

// // console.log("Updated profile:", latestProfile.data);
// // console.log(res.data);
// // localStorage.setItem(
// //   "user_data",
// //   JSON.stringify(updatedUser)
// // );

// // setClientData(updatedUser);

// // showSuccess("Profile Updated Successfully");

// // console.log(res.data);
// //     console.log(res.data);

// //   } catch (error) {
// //     console.log(error);

// //     showError(
// //       error.response?.data?.message ||
// //       "Profile Update Failed"
// //     );
// //   }
// // };
// //   return (
// //     <div className="container-fluid py-4 bg-light min-vh-100">

// //       <div className="card border-0 shadow rounded-4">
// //         <div className="card-body p-4">

   
// //           <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">

// //             <div className="d-flex align-items-center">

// //   <div className="position-relative">

// //     <img
// //       src={profilePreview}
// //       alt="profile"
// //       className="rounded-circle border border-2 border-primary"
// //       width="90"
// //       height="90"
// //       style={{ objectFit: "cover" }}
// //     />

// //     <label
// //       htmlFor="profile-upload"
// //       className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
// //       style={{
// //         width: "30px",
// //         height: "30px",
// //         cursor: "pointer",
// //       }}
// //     >
// // <FaCamera size={14} />
// //     </label>

// //     <input
// //       id="profile-upload"
// //       type="file"
// //       accept="image/*"
// //       style={{ display: "none" }}
// //       onChange={handleProfileChange}
// //     />

// //   </div>


// //   <div className="ms-3">
// //   <h4 className="mb-1 fw-bold">
// //     {profileData.business_name || "Business Name"}
// //   </h4>

// //   <p className="text-muted mb-0">
// //     {profileData.email || "No Email"}
// //   </p>
// // </div>

// // </div>

// // <button
// //   className="btn rounded-pill px-4 fw-semibold text-white shadow-sm"
// //   style={{
// //     backgroundColor: "var(--primary-color)",
// //     borderColor: "var(--primary-color)",
// //   }}
// //   onClick={() => navigate("/branch")}
// // >
// //   Branch
// // </button>

// //           </div>

     
// //           <div className="row g-4">

// //           <div className="col-md-4">
// //   <label className="form-label fw-semibold mb-2">
// //     Full Name
// //   </label>

// //   <input
// //     type="text"
// //     className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //     placeholder="Enter Name"
// //     value={profileData.business_name}
// //     onChange={(e) =>
// //       setProfileData({
// //         ...profileData,
// //         business_name: e.target.value,
// //       })
// //     }
// //   />
// // </div>

// //             <div className="col-md-4">
// //               <label className="form-label fw-semibold mb-2">

// //                 GSTIN
// //               </label>

// //               <input
// //                 type="text"
// //                   className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //                 // className="form-control"
// //                 placeholder="Enter GSTIN"
// //                 value={profileData.gst}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       gst: e.target.value,
// //     })
// //   }
// //               />
// //             </div>
            
// //             <div className="col-md-4">
// //               <label className="form-label fw-semibold">
// //                 Email
// //               </label>

// //               <input
// //                 type="text"
// //                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //                 // className="form-control"
// //                 placeholder="Enter Email"
// //                 value={profileData.email}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       email: e.target.value,
// //     })
// //   }
// //               />
// //             </div>
               
// //             <div className="col-md-4">
// //               <label className="form-label fw-semibold">
// //                 Mobile
// //               </label>

// //               <input
// //                 type="text"
// //                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //                 // className="form-control"
// //                 placeholder="Enter mobile"
// //                 value={profileData.mobile}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       mobile: e.target.value,
// //     })
// //   }
// //               />
// //             </div>
            
// //             <div className="col-md-4">
// //               <label className="form-label fw-semibold">
// //                 Address
// //               </label>

// //               <input
// //                 type="text"
// //                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //                 // className="form-control"
// //                 placeholder="Enter Address"
// //                 value={profileData.address}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       address: e.target.value,
// //     })
// //   }
// //               />
// //             </div>

// //             <div className="col-md-4">
     

// //      <div className="col-md-12">
// //   <label className="form-label fw-semibold">
// //     State
// //   </label>

// // <select
// //   className="form-select form-select-lg rounded-4 shadow-sm border-2"
// //   value={profileData.state}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       state: e.target.value,
// //     })
// //   }
// // >
// //   <option value="">Select State</option>

// //   <option value="Andhra Pradesh">Andhra Pradesh</option>
// //   <option value="Arunachal Pradesh">Arunachal Pradesh</option>
// //   <option value="Assam">Assam</option>
// //   <option value="Bihar">Bihar</option>
// //   <option value="Chhattisgarh">Chhattisgarh</option>
// //   <option value="Delhi">Delhi</option>
// //   <option value="Goa">Goa</option>
// //   <option value="Gujarat">Gujarat</option>
// //   <option value="Haryana">Haryana</option>
// //   <option value="Himachal Pradesh">Himachal Pradesh</option>
// //   <option value="Jharkhand">Jharkhand</option>
// //   <option value="Karnataka">Karnataka</option>
// //   <option value="Kerala">Kerala</option>
// //   <option value="Madhya Pradesh">Madhya Pradesh</option>
// //   <option value="Maharashtra">Maharashtra</option>
// //   <option value="Manipur">Manipur</option>
// //   <option value="Meghalaya">Meghalaya</option>
// //   <option value="Mizoram">Mizoram</option>
// //   <option value="Nagaland">Nagaland</option>
// //   <option value="Odisha">Odisha</option>
// //   <option value="Punjab">Punjab</option>
// //   <option value="Rajasthan">Rajasthan</option>
// //   <option value="Sikkim">Sikkim</option>
// //   <option value="Tamil Nadu">Tamil Nadu</option>
// //   <option value="Telangana">Telangana</option>
// //   <option value="Tripura">Tripura</option>
// //   <option value="Uttar Pradesh">Uttar Pradesh</option>
// //   <option value="Uttarakhand">Uttarakhand</option>
// //   <option value="West Bengal">West Bengal</option>
// // </select>
// // </div>

// //             </div>
// // <div className="col-md-4">
// //   <label className="form-label fw-semibold">
// //     Business Type
// //   </label>

// // <select
// //   className="form-select form-select-lg rounded-4 shadow-sm border-2"
// //   value={profileData.type}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       type: e.target.value,
// //     })
// //   }
// // >
// //   <option value="">
// //     Select Business Type
// //   </option>

// //   <option value="Service">
// //     Service
// //   </option>

// //   <option value="Wholeseller">
// //     Wholeseller
// //   </option>

// //   <option value="Retail">
// //     Retail
// //   </option>
// // </select>
// // </div>
// //              <div className="col-md-4">
// //               <label className="form-label fw-semibold">
// //                 Area pincode
// //               </label>

// //               <input
// //                 type="text"
// //                   className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //                 // className="form-control"
// //                 placeholder="Enter Area pincode"
// //                  value={profileData.pin}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       pin: e.target.value,
// //     })
// //   }
              
// //               />
// //             </div>
// //               <div className="col-md-4">
// //               <label className="form-label fw-semibold">
// //             Description
// //               </label>

// //               <input
// //                 type="text"
// //                   className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //                 // className="form-control"
// //                 placeholder="Enter Description"
// //                              value={profileData.description}
// //   onChange={(e) =>
// //     setProfileData({
// //       ...profileData,
// //       description: e.target.value,
// //     })
// //   }
// //               />
// //             </div>
// //               {/* SECURITY SECTION */}
// // <div className="mt-5 pt-4 border-top">

// //   <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

// //     <div>
// //       <h5 className="fw-bold mb-1">
// //         Security
// //       </h5>

// //       <p className="text-muted mb-0">
// //         Manage your account password and security.
// //       </p>
// //     </div>

// //     <button
// //       type="button"
// //       className="btn rounded-pill px-4 fw-semibold text-white shadow-sm"
// //       style={{
// //         background: "var(--primary-color)",
// //       }}
// //       onClick={() =>
// //         setShowPasswordSection(!showPasswordSection)
// //       }
// //     >
// //       {showPasswordSection
// //         ? "Cancel"
// //         : "Change Password"}
// //     </button>

// //   </div>


// // {showPasswordSection && (
// //   <div
// //     className="mt-5 p-4 rounded-4 border bg-light"
// //     style={{ maxWidth: "650px" }}
// //   >
// //     <h6 className="fw-bold mb-4">Change Password</h6>

// //     {/* Current Password */}
// //     <div className="mb-3">
// //       <label className="form-label fw-semibold mb-2">
// //         Current Password
// //       </label>

// //       <div className="position-relative">
// //         <input
// //           type={showCurrentPassword ? "text" : "password"}
// //           className="form-control form-control-lg rounded-4 shadow-sm pe-5"
// //           value={passwordData.currentPassword}
// //           onChange={(e) =>
// //             setPasswordData({
// //               ...passwordData,
// //               currentPassword: e.target.value,
// //             })
// //           }
// //         />

// //         <button
// //           type="button"
// //           className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
// //           onClick={() => setShowCurrentPassword(!showCurrentPassword)}
// //         >
// //           {showCurrentPassword ? <EyeOff size={19} /> : <Eye size={19} />}
// //         </button>
// //       </div>
// //     </div>

// //     {/* New Password */}
// //     <div className="mb-3">
// //       <label className="form-label fw-semibold mb-2">
// //         New Password
// //       </label>

// //       <div className="position-relative">
// //         <input
// //           type={showNewPassword ? "text" : "password"}
// //           className="form-control form-control-lg rounded-4 shadow-sm pe-5"
// //           placeholder="Enter new password"
// //           value={passwordData.newPassword}
// //           onChange={(e) =>
// //             setPasswordData({
// //               ...passwordData,
// //               newPassword: e.target.value,
// //             })
// //           }
// //         />

// //         <button
// //           type="button"
// //           className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
// //           onClick={() => setShowNewPassword(!showNewPassword)}
// //         >
// //           {showNewPassword ? <EyeOff size={19} /> : <Eye size={19} />}
// //         </button>
// //       </div>
// //     </div>

// //     {/* Confirm Password */}
// //     <div className="mb-4">
// //       <label className="form-label fw-semibold mb-2">
// //         Confirm New Password
// //       </label>

// //       <div className="position-relative">
// //         <input
// //           type={showConfirmPassword ? "text" : "password"}
// //           className="form-control form-control-lg rounded-4 shadow-sm pe-5"
// //           placeholder="Confirm new password"
// //           value={passwordData.confirmPassword}
// //           onChange={(e) =>
// //             setPasswordData({
// //               ...passwordData,
// //               confirmPassword: e.target.value,
// //             })
// //           }
// //         />

// //         <button
// //           type="button"
// //           className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
// //           onClick={() =>
// //             setShowConfirmPassword(!showConfirmPassword)
// //           }
// //         >
// //           {showConfirmPassword ? (
// //             <EyeOff size={19} />
// //           ) : (
// //             <Eye size={19} />
// //           )}
// //         </button>
// //       </div>
// //     </div>

// //     <div className="d-flex gap-3 mt-2">
// //       <button
// //         type="button"
// //         className="btn px-4 py-2 rounded-pill text-white fw-semibold"
// //         style={{ background: "var(--primary-color)" }}
// //         onClick={handleChangePassword}
// //       >
// //         Update Password
// //       </button>

// //       <button
// //         type="button"
// //         className="btn btn-outline-secondary px-4 py-2 rounded-pill fw-semibold"
// //         onClick={() => {
// //           setPasswordData({
// //             currentPassword: passwordData.currentPassword,
// //             newPassword: "",
// //             confirmPassword: "",
// //           });
// //           setShowPasswordSection(false);
// //         }}
// //       >
// //         Cancel
// //       </button>
// //     </div>
// //   </div>
// // )}

// // </div>


// // {/* 
// //             <div className="col-md-6">
// //               <label className="form-label fw-semibold">
// //                 Time Zone
// //               </label>

// //               <select className="form-select">
// //                 <option>Select Time Zone</option>
// //                 <option>Asia/Kolkata</option>
// //                 <option>UTC</option>
// //               </select>
// //             </div> */}

// //           </div>

// //    <div className="mt-5">

// //   <h5 className="fw-bold mb-3">
// //     Signature
// //   </h5>

// //   <div
  
// //    className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //     style={{ maxWidth: "400px" }}
// //   >


// //   {(signaturePreview || signatureImage) ? (
// //   <img
// //     src={signaturePreview || signatureImage}
// //     alt="Signature"
// //     style={{
// //       width: "100%",
// //       maxHeight: "120px",
// //       objectFit: "contain",
// //     }}
// //   />
// // ) : (
// //   <div className="text-muted">
    
// //     No Signature Uploaded
// //   </div>
// // )}

// //     <input
// //       type="file"
// //       accept="image/*"
// //     className="form-control form-control-lg rounded-4 shadow-sm border-2"
// //       onChange={handleSignatureChange}
// //     />

// //   </div>



            
// //           </div>

        
// //           <div className="text-end mt-5">
// //     <button
// //   className="btn px-5 py-2 rounded-pill text-white fw-semibold shadow-sm"
// //   style={{
// //     background: "var(--primary-color)",
// //   }}
// //   onClick={handleSaveProfile}
// // >
// //   Save Changes
// // </button>

// //           </div>
          

// //         </div>
// //       </div>

// //     </div>
// //   );
// // };

// // export default Profile;


// import React, { useState, useEffect } from "react";
// import profileImg from "../../assets/profile.png";
// import "bootstrap/dist/css/bootstrap.min.css";
// import { FaCamera } from "react-icons/fa";
// import axios from "axios";
// import { Eye, EyeOff } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// import {
//   showSuccess,
//   showError,
// } from "../../General/Toast";

// const Profile = ({ clientData, setClientData }) => {

//   const navigate = useNavigate();

//   // =========================
//   // PASSWORD VISIBILITY
//   // =========================
//   const [showCurrentPassword, setShowCurrentPassword] =
//     useState(false);

//   const [showNewPassword, setShowNewPassword] =
//     useState(false);

//   const [showConfirmPassword, setShowConfirmPassword] =
//     useState(false);


//   // =========================
//   // PROFILE STATES
//   // =========================
//   const [signaturePreview, setSignaturePreview] =
//     useState(null);

//   const [profilePreview, setProfilePreview] =
//     useState(profileImg);


//   // =========================
//   // PASSWORD DATA
//   // =========================
//   const [passwordData, setPasswordData] = useState({
//     currentPassword: "",
//     newPassword: "",
//     confirmPassword: "",
//   });


//   const [showPasswordSection, setShowPasswordSection] =
//     useState(false);


//   // =========================
//   // PROFILE DATA
//   // =========================
//   const [profileData, setProfileData] = useState({
//     business_name: "",
//     gst: "",
//     email: "",
//     mobile: "",
//     address: "",
//     state: "",
//     type: "",
//     pin: "",
//     description: "",
//   });


//   const [profileImage, setProfileImage] = useState(null);

//   const [signatureImage, setSignatureImage] =
//     useState(null);
// const [showSaveModal, setShowSaveModal] = useState(false);

//   // =========================
//   // PROFILE IMAGE CHANGE
//   // =========================
//   const handleProfileChange = (e) => {

//     const file = e.target.files[0];

//     if (file) {

//       setProfileImage(file);

//       setProfilePreview(
//         URL.createObjectURL(file)
//       );
//     }
//   };


//   // =========================
//   // FETCH PROFILE
//   // =========================
//   const fetchProfile = async () => {

//     try {

//       const userData = JSON.parse(
//         localStorage.getItem("user_data")
//       );

//       if (!userData?.id) {
//         showError("User information not found");
//         return;
//       }


//       const res = await axios.get(
//         `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
//       );


//       console.log(
//         res.data,
//         "manageBussiness"
//       );


//       // =========================
//       // SET PROFILE DATA
//       // =========================
//       setProfileData({
//         business_name:
//           res.data.business_name || "",

//         gst:
//           res.data.gst || "",

//         email:
//           res.data.email || "",

//         mobile:
//           res.data.mobile || "",

//         address:
//           res.data.address || "",

//         state:
//           res.data.state || "",

//         type:
//           res.data.type || "",

//         pin:
//           res.data.pin || "",

//         description:
//           res.data.description || "",
//       });


//       // =========================
//       // CURRENT PASSWORD AUTO FILL
//       // =========================
//       setPasswordData({
//         currentPassword:
//           res.data.pass || "",

//         newPassword: "",

//         confirmPassword: "",
//       });


//       // =========================
//       // PROFILE IMAGE
//       // =========================
//       if (res.data.image) {

//         const imageUrl =
//           `https://api.dectwinbilling.com/dUploads/${res.data.image}`;

//         setProfileImage(imageUrl);

//         setProfilePreview(imageUrl);
//       }


//       // =========================
//       // SIGNATURE
//       // =========================
//       if (res.data.sign) {

//         const signUrl =
//           `https://api.dectwinbilling.com/dUploads/${res.data.sign}`;

//         setSignatureImage(signUrl);
//       }

//     } catch (error) {

//       console.log(
//         "Fetch Profile Error:",
//         error
//       );
//     }
//   };


//   // =========================
//   // LOAD PROFILE
//   // =========================
//   useEffect(() => {

//     fetchProfile();

//   }, []);


//   // =========================
//   // SIGNATURE CHANGE
//   // =========================
//   const handleSignatureChange = (e) => {

//     const file = e.target.files[0];

//     if (file) {

//       setSignatureImage(file);

//       setSignaturePreview(
//         URL.createObjectURL(file)
//       );
//     }
//   };


//   // =========================
//   // CHANGE PASSWORD
//   // =========================
//   const handleChangePassword = async () => {

//     try {

//       const userData = JSON.parse(
//         localStorage.getItem("user_data")
//       );


//       if (!userData?.id) {

//         showError(
//           "User information not found"
//         );

//         return;
//       }


//       // Current Password
//       if (!passwordData.currentPassword) {

//         showError(
//           "Please enter current password"
//         );

//         return;
//       }


//       // New Password
//       if (!passwordData.newPassword) {

//         showError(
//           "Please enter new password"
//         );

//         return;
//       }


//       // Minimum 6 characters
//       if (
//         passwordData.newPassword.length < 6
//       ) {

//         showError(
//           "New password must be at least 6 characters"
//         );

//         return;
//       }


//       // Confirm Password
//       if (
//         passwordData.newPassword !==
//         passwordData.confirmPassword
//       ) {

//         showError(
//           "New password and confirm password do not match"
//         );

//         return;
//       }


//       // =========================
//       // API
//       // =========================
//       const res = await axios.put(
//         `https://api.dectwinbilling.com/change-password/${userData.id}`,
//         {
//           currentPassword:
//             passwordData.currentPassword,

//           newPassword:
//             passwordData.newPassword,
//         }
//       );


//       // =========================
//       // SUCCESS
//       // =========================
//       showSuccess(
//         res.data?.message ||
//         "Password changed successfully"
//       );


//       // Clear new passwords
//       setPasswordData({
//         currentPassword:
//           passwordData.currentPassword,

//         newPassword: "",

//         confirmPassword: "",
//       });


    
//       setShowPasswordSection(false);


    
//       setShowCurrentPassword(false);

//       setShowNewPassword(false);

//       setShowConfirmPassword(false);


//     } catch (error) {

//       console.log(
//         "Change Password Error:",
//         error
//       );


//       showError(
//         error.response?.data?.message ||
//         "Unable to change password"
//       );
//     }
//   };

//     const userData = JSON.parse(
//         localStorage.getItem("user_data")
//       );


//       if (!userData?.id) {

//         showError(
//           "User information not found"
//         );

//         return;
//       }
//   // =========================
//   // SAVE PROFILE
//   // =========================
//   // const handleSaveProfile = async () => {
    

//   //   try {

  


//   //     const formData = new FormData();


//   //     // =========================
//   //     // PROFILE FIELDS
//   //     // =========================
//   //     formData.append(
//   //       "business_name",
//   //       profileData.business_name
//   //     );


//   //     formData.append(
//   //       "gst",
//   //       profileData.gst
//   //     );


//   //     formData.append(
//   //       "email",
//   //       profileData.email
//   //     );


//   //     formData.append(
//   //       "mobile",
//   //       profileData.mobile
//   //     );


//   //     formData.append(
//   //       "address",
//   //       profileData.address
//   //     );


//   //     formData.append(
//   //       "state",
//   //       profileData.state
//   //     );


//   //     formData.append(
//   //       "type",
//   //       profileData.type
//   //     );


//   //     formData.append(
//   //       "pin",
//   //       profileData.pin
//   //     );


//   //     formData.append(
//   //       "description",
//   //       profileData.description
//   //     );


//   //     // =========================
//   //     // PROFILE IMAGE
//   //     // =========================
//   //     if (
//   //       profileImage instanceof File
//   //     ) {

//   //       formData.append(
//   //         "image",
//   //         profileImage
//   //       );
//   //     }


//   //     // =========================
//   //     // SIGNATURE
//   //     // =========================
//   //     if (
//   //       signatureImage instanceof File
//   //     ) {

//   //       formData.append(
//   //         "sign",
//   //         signatureImage
//   //       );
//   //     }


//   //     // =========================
//   //     // UPDATE PROFILE API
//   //     // =========================
//   //     const res = await axios.put(
//   //       `https://api.dectwinbilling.com/update-profile/${userData.id}`,
//   //       formData,
//   //       {
//   //         headers: {
//   //           "Content-Type":
//   //             "multipart/form-data",
//   //         },
//   //       }
//   //     );


//   //     // =========================
//   //     // FETCH UPDATED PROFILE
//   //     // =========================
//   //     const latestProfile =
//   //       await axios.get(
//   //         `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
//   //       );


//   //     // =========================
//   //     // UPDATED USER
//   //     // =========================
//   //     const updatedUser = {

//   //       ...userData,

//   //       ...profileData,

//   //       image:
//   //         latestProfile.data.image ||
//   //         userData.image,

//   //       sign:
//   //         latestProfile.data.sign ||
//   //         userData.sign,

//   //       imageUpdatedAt:
//   //         Date.now(),
//   //     };


//   //     // =========================
//   //     // SAVE LOCAL STORAGE
//   //     // =========================
//   //     localStorage.setItem(
//   //       "user_data",
//   //       JSON.stringify(updatedUser)
//   //     );


//   //     // =========================
//   //     // UPDATE PARENT STATE
//   //     // =========================
//   //     setClientData(updatedUser);


//   //     // =========================
//   //     // ONLY ONE SUCCESS TOAST
//   //     // =========================
//   //     showSuccess(
//   //       "Profile Updated Successfully"
//   //     );


//   //     console.log(
//   //       "Updated profile:",
//   //       latestProfile.data
//   //     );


//   //     console.log(
//   //       res.data
//   //     );

//   //   } catch (error) {

//   //     console.log(
//   //       "Profile Update Error:",
//   //       error
//   //     );


//   //     showError(
//   //       error.response?.data?.message ||
//   //       "Profile Update Failed"
//   //     );
//   //   }
//   // };
// // const handleSaveProfile = async () => {


// //   const confirmSave = window.confirm(
// //     "Do you want to save changes?"
// //   );

// //   // Cancel clicked
// //   if (!confirmSave) {
// //     return;
// //   }

// //   try {

// //     // =========================
// //     // USER DATA
// //     // =========================
// //     const userData = JSON.parse(
// //       localStorage.getItem("user_data")
// //     );

// //     if (!userData?.id) {
// //       showError("User information not found");
// //       return;
// //     }


// //     // =========================
// //     // FORM DATA
// //     // =========================
// //     const formData = new FormData();


// //     // =========================
// //     // PROFILE FIELDS
// //     // =========================
// //     formData.append(
// //       "business_name",
// //       profileData.business_name
// //     );

// //     formData.append(
// //       "gst",
// //       profileData.gst
// //     );

// //     formData.append(
// //       "email",
// //       profileData.email
// //     );

// //     formData.append(
// //       "mobile",
// //       profileData.mobile
// //     );

// //     formData.append(
// //       "address",
// //       profileData.address
// //     );

// //     formData.append(
// //       "state",
// //       profileData.state
// //     );

// //     formData.append(
// //       "type",
// //       profileData.type
// //     );

// //     formData.append(
// //       "pin",
// //       profileData.pin
// //     );

// //     formData.append(
// //       "description",
// //       profileData.description
// //     );


// //     // =========================
// //     // PROFILE IMAGE
// //     // =========================
// //     if (profileImage instanceof File) {

// //       formData.append(
// //         "image",
// //         profileImage
// //       );

// //     }


// //     // =========================
// //     // SIGNATURE
// //     // =========================
// //     if (signatureImage instanceof File) {

// //       formData.append(
// //         "sign",
// //         signatureImage
// //       );

// //     }


// //     // =========================
// //     // UPDATE PROFILE API
// //     // =========================
// //     const res = await axios.put(
// //       `https://api.dectwinbilling.com/update-profile/${userData.id}`,
// //       formData,
// //       {
// //         headers: {
// //           "Content-Type": "multipart/form-data",
// //         },
// //       }
// //     );


// //     // =========================
// //     // FETCH UPDATED PROFILE
// //     // =========================
// //     const latestProfile = await axios.get(
// //       `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
// //     );


// //     // =========================
// //     // UPDATED USER
// //     // =========================
// //     const updatedUser = {

// //       ...userData,

// //       ...profileData,

// //       image:
// //         latestProfile.data.image ||
// //         userData.image,

// //       sign:
// //         latestProfile.data.sign ||
// //         userData.sign,

// //       imageUpdatedAt:
// //         Date.now(),

// //     };


// //     // =========================
// //     // SAVE LOCAL STORAGE
// //     // =========================
// //     localStorage.setItem(
// //       "user_data",
// //       JSON.stringify(updatedUser)
// //     );


// //     // =========================
// //     // UPDATE PARENT STATE
// //     // =========================
// //     setClientData(updatedUser);


// //     // =========================
// //     // SUCCESS TOAST
// //     // =========================
// //     showSuccess(
// //       "Profile Updated Successfully"
// //     );


// //     // =========================
// //     // CONSOLE
// //     // =========================
// //     console.log(
// //       "Updated profile:",
// //       latestProfile.data
// //     );

// //     console.log(
// //       "Update response:",
// //       res.data
// //     );


// //   } catch (error) {

// //     console.log(
// //       "Profile Update Error:",
// //       error
// //     );


// //     showError(
// //       error.response?.data?.message ||
// //       "Profile Update Failed"
// //     );

// //   }
// // };
// // =========================
// // OPEN SAVE CONFIRMATION MODAL
// // =========================
// const handleSaveProfile = () => {
//   setShowSaveModal(true);
// };

// // =========================
// // SAVE PROFILE
// // =========================
// const saveProfile = async () => {

//   // Close confirmation modal
//   setShowSaveModal(false);

//   try {
//     // =========================
//     // USER DATA
//     // =========================
//     const userData = JSON.parse(
//       localStorage.getItem("user_data")
//     );

//     if (!userData?.id) {
//       showError("User information not found");
//       return;
//     }

//     // =========================
//     // FORM DATA
//     // =========================
//     const formData = new FormData();

//     // =========================
//     // PROFILE FIELDS
//     // =========================
//     formData.append(
//       "business_name",
//       profileData.business_name
//     );

//     formData.append(
//       "gst",
//       profileData.gst
//     );

//     formData.append(
//       "email",
//       profileData.email
//     );

//     formData.append(
//       "mobile",
//       profileData.mobile
//     );

//     formData.append(
//       "address",
//       profileData.address
//     );

//     formData.append(
//       "state",
//       profileData.state
//     );

//     formData.append(
//       "type",
//       profileData.type
//     );

//     formData.append(
//       "pin",
//       profileData.pin
//     );

//     formData.append(
//       "description",
//       profileData.description
//     );

//     // =========================
//     // PROFILE IMAGE
//     // =========================
//     if (profileImage instanceof File) {
//       formData.append(
//         "image",
//         profileImage
//       );
//     }

//     // =========================
//     // SIGNATURE
//     // =========================
//     if (signatureImage instanceof File) {
//       formData.append(
//         "sign",
//         signatureImage
//       );
//     }

//     // =========================
//     // UPDATE PROFILE API
//     // =========================
//     const res = await axios.put(
//       `https://api.dectwinbilling.com/update-profile/${userData.id}`,
//       formData,
//       {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       }
//     );

//     // =========================
//     // FETCH UPDATED PROFILE
//     // =========================
//     const latestProfile = await axios.get(
//       `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
//     );

//     // =========================
//     // UPDATED USER
//     // =========================
//     const updatedUser = {
//       ...userData,
//       ...profileData,

//       image:
//         latestProfile.data.image ||
//         userData.image,

//       sign:
//         latestProfile.data.sign ||
//         userData.sign,

//       imageUpdatedAt: Date.now(),
//     };

//     // =========================
//     // SAVE LOCAL STORAGE
//     // =========================
//     localStorage.setItem(
//       "user_data",
//       JSON.stringify(updatedUser)
//     );

//     // =========================
//     // UPDATE PARENT STATE
//     // =========================
//     setClientData(updatedUser);

//     // =========================
//     // SUCCESS
//     // =========================
//     showSuccess(
//       "Profile Updated Successfully"
//     );

//     console.log(
//       "Updated profile:",
//       latestProfile.data
//     );

//     console.log(
//       "Update response:",
//       res.data
//     );

//   } catch (error) {

//     console.log(
//       "Profile Update Error:",
//       error
//     );

//     showError(
//       error.response?.data?.message ||
//       "Profile Update Failed"
//     );
//   }
// };

//   return (

//     <div className="container-fluid py-4 bg-light min-vh-100">

//       <div className="card border-0 shadow rounded-4">

//         <div className="card-body p-4">


//           {/* =====================================
//               PROFILE HEADER
//           ====================================== */}

//           <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">

//             <div className="d-flex align-items-center">

//               {/* PROFILE IMAGE */}

//               <div className="position-relative">

//                 <img
//                   src={profilePreview}
//                   alt="profile"
//                   className="rounded-circle border border-2 border-primary"
//                   width="90"
//                   height="90"
//                   style={{
//                     objectFit: "cover",
//                   }}
//                 />


//                 <label
//                   htmlFor="profile-upload"
//                   className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
//                   style={{
//                     width: "30px",
//                     height: "30px",
//                     cursor: "pointer",
//                   }}
//                 >

//                   <FaCamera size={14} />

//                 </label>


//                 <input
//                   id="profile-upload"
//                   type="file"
//                   accept="image/*"
//                   style={{
//                     display: "none",
//                   }}
//                   onChange={
//                     handleProfileChange
//                   }
//                 />

//               </div>


//               {/* BUSINESS INFO */}

//               <div className="ms-3">

//                 <h4 className="mb-1 fw-bold">

//                   {profileData.business_name ||
//                     "Business Name"}

//                 </h4>


//                 <p className="text-muted mb-0">

//                   {profileData.email ||
//                     "No Email"}

//                 </p>

//               </div>

//             </div>


//             {/* BRANCH */}

//             <button
//               type="button"
//               className="btn rounded-pill px-4 fw-semibold text-white shadow-sm"
//               style={{
//                 backgroundColor:
//                   "var(--primary-color)",

//                 borderColor:
//                   "var(--primary-color)",
//               }}
//               onClick={() =>
//                 navigate("/branch")
//               }
//             >

//               Branch

//             </button>

//           </div>


//           {/* =====================================
//               PROFILE FORM
//           ====================================== */}

//           <div className="row g-4">


//             {/* FULL NAME */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Full Name
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter Name"
//                 value={
//                   profileData.business_name
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     business_name:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* GST */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 GSTIN
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter GSTIN"
//                 value={
//                   profileData.gst
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     gst:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* EMAIL */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Email
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter Email"
//                 value={
//                   profileData.email
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     email:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* MOBILE */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Mobile
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter mobile"
//                 value={
//                   profileData.mobile
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     mobile:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* ADDRESS */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Address
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter Address"
//                 value={
//                   profileData.address
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     address:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* STATE */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 State
//               </label>


//               <select
//                 className="form-select form-select-lg rounded-4 shadow-sm border-2"
//                 value={
//                   profileData.state
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     state:
//                       e.target.value,
//                   })
//                 }
//               >

//                 <option value="">
//                   Select State
//                 </option>

//                 <option value="Andhra Pradesh">
//                   Andhra Pradesh
//                 </option>

//                 <option value="Arunachal Pradesh">
//                   Arunachal Pradesh
//                 </option>

//                 <option value="Assam">
//                   Assam
//                 </option>

//                 <option value="Bihar">
//                   Bihar
//                 </option>

//                 <option value="Chhattisgarh">
//                   Chhattisgarh
//                 </option>

//                 <option value="Delhi">
//                   Delhi
//                 </option>

//                 <option value="Goa">
//                   Goa
//                 </option>

//                 <option value="Gujarat">
//                   Gujarat
//                 </option>

//                 <option value="Haryana">
//                   Haryana
//                 </option>

//                 <option value="Himachal Pradesh">
//                   Himachal Pradesh
//                 </option>

//                 <option value="Jharkhand">
//                   Jharkhand
//                 </option>

//                 <option value="Karnataka">
//                   Karnataka
//                 </option>

//                 <option value="Kerala">
//                   Kerala
//                 </option>

//                 <option value="Madhya Pradesh">
//                   Madhya Pradesh
//                 </option>

//                 <option value="Maharashtra">
//                   Maharashtra
//                 </option>

//                 <option value="Manipur">
//                   Manipur
//                 </option>

//                 <option value="Meghalaya">
//                   Meghalaya
//                 </option>

//                 <option value="Mizoram">
//                   Mizoram
//                 </option>

//                 <option value="Nagaland">
//                   Nagaland
//                 </option>

//                 <option value="Odisha">
//                   Odisha
//                 </option>

//                 <option value="Punjab">
//                   Punjab
//                 </option>

//                 <option value="Rajasthan">
//                   Rajasthan
//                 </option>

//                 <option value="Sikkim">
//                   Sikkim
//                 </option>

//                 <option value="Tamil Nadu">
//                   Tamil Nadu
//                 </option>

//                 <option value="Telangana">
//                   Telangana
//                 </option>

//                 <option value="Tripura">
//                   Tripura
//                 </option>

//                 <option value="Uttar Pradesh">
//                   Uttar Pradesh
//                 </option>

//                 <option value="Uttarakhand">
//                   Uttarakhand
//                 </option>

//                 <option value="West Bengal">
//                   West Bengal
//                 </option>

//               </select>

//             </div>


//             {/* BUSINESS TYPE */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Business Type
//               </label>


//               <select
//                 className="form-select form-select-lg rounded-4 shadow-sm border-2"
//                 value={
//                   profileData.type
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     type:
//                       e.target.value,
//                   })
//                 }
//               >

//                 <option value="">
//                   Select Business Type
//                 </option>

//                 <option value="Service">
//                   Service
//                 </option>

//                 <option value="Wholeseller">
//                   Wholeseller
//                 </option>

//                 <option value="Retail">
//                   Retail
//                 </option>

//               </select>

//             </div>


//             {/* PINCODE */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Area pincode
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter Area pincode"
//                 value={
//                   profileData.pin
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     pin:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* DESCRIPTION */}

//             <div className="col-md-4">

//               <label className="form-label fw-semibold mb-2">
//                 Description
//               </label>


//               <input
//                 type="text"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 placeholder="Enter Description"
//                 value={
//                   profileData.description
//                 }
//                 onChange={(e) =>
//                   setProfileData({
//                     ...profileData,

//                     description:
//                       e.target.value,
//                   })
//                 }
//               />

//             </div>


//             {/* =====================================
//                 SECURITY
//             ====================================== */}

//             <div className="col-12">

//               <div className="mt-5 pt-4 border-top">

//                 <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">

//                   <div>

//                     <h5 className="fw-bold mb-1">
//                       Security
//                     </h5>


//                     <p className="text-muted mb-0">
//                       Manage your account password and security.
//                     </p>

//                   </div>


//                   <button
//                     type="button"
//                     className="btn rounded-pill px-4 fw-semibold text-white shadow-sm"
//                     style={{
//                       background:
//                         "var(--primary-color)",
//                     }}
//                     onClick={() =>
//                       setShowPasswordSection(
//                         !showPasswordSection
//                       )
//                     }
//                   >

//                     {showPasswordSection
//                       ? "Cancel"
//                       : "Change Password"}

//                   </button>

//                 </div>


//                 {/* =================================
//                     CHANGE PASSWORD BOX
//                 ================================= */}
//   {showSaveModal && (
//   <div
//     className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
//     style={{
//       background: "rgba(0,0,0,0.45)",
//       zIndex: 9999,
//     }}
//   >
//     <div
//       className="bg-white rounded-4 shadow-lg p-4"
//       style={{
//         width: "90%",
//         maxWidth: "420px",
//       }}
//     >
//       <h5 className="fw-bold mb-2">
//         Save Changes
//       </h5>

//       <p className="text-muted mb-4">
//         Do you want to save changes?
//       </p>

//       <div className="d-flex justify-content-end gap-3">

//         <button
//           type="button"
//           className="btn btn-outline-secondary rounded-pill px-4"
//           onClick={() => setShowSaveModal(false)}
//         >
//           Cancel
//         </button>

//         <button
//           type="button"
//           className="btn rounded-pill px-4 text-white"
//           style={{
//             background: "var(--primary-color)",
//           }}
//           onClick={saveProfile}
//         >
//           Yes, Save
//         </button>

//       </div>
//     </div>
//   </div>
// )}
//                 {showPasswordSection && (

//                   <div
//                     className="mt-5 p-4 rounded-4 border bg-light"
//                     style={{
//                       maxWidth: "650px",
//                     }}
//                   >

//                     <h6 className="fw-bold mb-4">
//                       Change Password
//                     </h6>


//                     {/* CURRENT PASSWORD */}

//                     <div className="mb-3">

//                       <label className="form-label fw-semibold mb-2">
//                         Current Password
//                       </label>


//                       <div className="position-relative">

//                         <input
//                           type={
//                             showCurrentPassword
//                               ? "text"
//                               : "password"
//                           }
//                           className="form-control form-control-lg rounded-4 shadow-sm pe-5"
//                           value={
//                             passwordData.currentPassword
//                           }
//                           onChange={(e) =>
//                             setPasswordData({
//                               ...passwordData,

//                               currentPassword:
//                                 e.target.value,
//                             })
//                           }
//                         />


//                         <button
//                           type="button"
//                           className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
//                           onClick={() =>
//                             setShowCurrentPassword(
//                               !showCurrentPassword
//                             )
//                           }
//                           style={{
//                             color: "#666",
//                           }}
//                         >

//                           {showCurrentPassword ? (
//                             <EyeOff size={19} />
//                           ) : (
//                             <Eye size={19} />
//                           )}

//                         </button>

//                       </div>

//                     </div>


//                     {/* NEW PASSWORD */}

//                     <div className="mb-3">

//                       <label className="form-label fw-semibold mb-2">
//                         New Password
//                       </label>


//                       <div className="position-relative">

//                         <input
//                           type={
//                             showNewPassword
//                               ? "text"
//                               : "password"
//                           }
//                           className="form-control form-control-lg rounded-4 shadow-sm pe-5"
//                           placeholder="Enter new password"
//                           value={
//                             passwordData.newPassword
//                           }
//                           onChange={(e) =>
//                             setPasswordData({
//                               ...passwordData,

//                               newPassword:
//                                 e.target.value,
//                             })
//                           }
//                         />


//                         <button
//                           type="button"
//                           className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
//                           onClick={() =>
//                             setShowNewPassword(
//                               !showNewPassword
//                             )
//                           }
//                           style={{
//                             color: "#666",
//                           }}
//                         >

//                           {showNewPassword ? (
//                             <EyeOff size={19} />
//                           ) : (
//                             <Eye size={19} />
//                           )}

//                         </button>

//                       </div>

//                     </div>


//                     {/* CONFIRM PASSWORD */}

//                     <div className="mb-4">

//                       <label className="form-label fw-semibold mb-2">
//                         Confirm New Password
//                       </label>


//                       <div className="position-relative">

//                         <input
//                           type={
//                             showConfirmPassword
//                               ? "text"
//                               : "password"
//                           }
//                           className="form-control form-control-lg rounded-4 shadow-sm pe-5"
//                           placeholder="Confirm new password"
//                           value={
//                             passwordData.confirmPassword
//                           }
//                           onChange={(e) =>
//                             setPasswordData({
//                               ...passwordData,

//                               confirmPassword:
//                                 e.target.value,
//                             })
//                           }
//                         />


//                         <button
//                           type="button"
//                           className="position-absolute top-50 end-0 translate-middle-y me-3 border-0 bg-transparent"
//                           onClick={() =>
//                             setShowConfirmPassword(
//                               !showConfirmPassword
//                             )
//                           }
//                           style={{
//                             color: "#666",
//                           }}
//                         >

//                           {showConfirmPassword ? (
//                             <EyeOff size={19} />
//                           ) : (
//                             <Eye size={19} />
//                           )}

//                         </button>

//                       </div>

//                     </div>


//                     {/* PASSWORD BUTTONS */}

//                     <div className="d-flex gap-3 mt-2 flex-wrap">

//                       <button
//                         type="button"
//                         className="btn px-4 py-2 rounded-pill text-white fw-semibold"
//                         style={{
//                           background:
//                             "var(--primary-color)",
//                         }}
//                         onClick={
//                           handleChangePassword
//                         }
//                       >

//                         Update Password

//                       </button>


//                       <button
//                         type="button"
//                         className="btn btn-outline-secondary px-4 py-2 rounded-pill fw-semibold"
//                         onClick={() => {

//                           setPasswordData({
//                             currentPassword:
//                               passwordData.currentPassword,

//                             newPassword: "",

//                             confirmPassword: "",
//                           });

//                           setShowPasswordSection(
//                             false
//                           );

//                           setShowCurrentPassword(
//                             false
//                           );

//                           setShowNewPassword(
//                             false
//                           );

//                           setShowConfirmPassword(
//                             false
//                           );

//                         }}
//                       >

//                         Cancel

//                       </button>

//                     </div>

//                   </div>

//                 )}

//               </div>

//             </div>

//           </div>


//           {/* =====================================
//               SIGNATURE
//           ====================================== */}

//           <div className="mt-5">

//             <h5 className="fw-bold mb-3">
//               Signature
//             </h5>


//             <div
//               className="form-control form-control-lg rounded-4 shadow-sm border-2"
//               style={{
//                 maxWidth: "400px",
//               }}
//             >

//               {/* SIGNATURE PREVIEW */}

//               {(
//                 signaturePreview ||
//                 signatureImage
//               ) ? (

//                 <img
//                   src={
//                     signaturePreview ||
//                     signatureImage
//                   }
//                   alt="Signature"
//                   style={{
//                     width: "100%",
//                     maxHeight: "120px",
//                     objectFit: "contain",
//                   }}
//                 />

//               ) : (

//                 <div className="text-muted mb-2">
//                   No Signature Uploaded
//                 </div>

//               )}


             

//               <input
//                 type="file"
//                 accept="image/*"
//                 className="form-control form-control-lg rounded-4 shadow-sm border-2"
//                 onChange={
//                   handleSignatureChange
//                 }
//               />

//             </div>

//           </div>


//           {/* =====================================
//               SAVE CHANGES
//           ====================================== */}

//           <div className="text-end mt-5">

//             {/* <button
//               type="button"
//               className="btn px-5 py-2 rounded-pill text-white fw-semibold shadow-sm"
//               style={{
//                 background:
//                   "var(--primary-color)",
//               }}
//               onClick={
//                 handleSaveProfile
//               }
//             >

//               Save Changes

//             </button> */}
// <button
//   type="button"
//   className="btn px-5 py-2 rounded-pill text-white fw-semibold shadow-sm"
//   style={{
//     background: "var(--primary-color)",
//   }}
//   onClick={handleSaveProfile}
// >
//   Save Changes
// </button>
//           </div>


//         </div>

//       </div>

//     </div>
    
    
//   );

// };

// export default Profile;
import React, { useState, useEffect } from "react";
import profileImg from "../../assets/profile.png";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCamera } from "react-icons/fa";
import axios from "axios";
import { Eye, EyeOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import {
  FaUser,
  FaIdCard,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaMapPin,
  FaBriefcase,
  FaAlignLeft,
} from "react-icons/fa";

import {
  showSuccess,
  showError,
} from "../../General/Toast";

const Profile = ({ clientData, setClientData }) => {
  const navigate = useNavigate();

  // =====================================================
  // PASSWORD VISIBILITY
  // =====================================================

  const [showCurrentPassword, setShowCurrentPassword] =
    useState(false);

  const [showNewPassword, setShowNewPassword] =
    useState(false);

  const [showConfirmPassword, setShowConfirmPassword] =
    useState(false);

  // =====================================================
  // PROFILE STATES
  // =====================================================

  const [signaturePreview, setSignaturePreview] =
    useState(null);

  const [profilePreview, setProfilePreview] =
    useState(profileImg);

  const [profileImage, setProfileImage] =
    useState(null);

  const [signatureImage, setSignatureImage] =
    useState(null);

  const [showSaveModal, setShowSaveModal] =
    useState(false);

  // =====================================================
  // PASSWORD DATA
  // =====================================================

  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [showPasswordSection, setShowPasswordSection] =
    useState(false);

  // =====================================================
  // PROFILE DATA
  // =====================================================

  const [profileData, setProfileData] = useState({
    business_name: "",
    gst: "",
    email: "",
    mobile: "",
    address: "",
    state: "",
    type: "",
    pin: "",
    description: "",
  });

  // =====================================================
  // PROFILE IMAGE CHANGE
  // =====================================================

  const handleProfileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setProfileImage(file);

      setProfilePreview(
        URL.createObjectURL(file)
      );
    }
  };

  // =====================================================
  // FETCH PROFILE
  // =====================================================

  const fetchProfile = async () => {
    try {
      const userData = JSON.parse(
        localStorage.getItem("user_data")
      );

      if (!userData?.id) {
        showError("User information not found");
        return;
      }

      const res = await axios.get(
        `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
      );

      console.log(
        res.data,
        "manageBussiness"
      );

      // =================================================
      // SET PROFILE DATA
      // =================================================

      setProfileData({
        business_name:
          res.data.business_name || "",

        gst:
          res.data.gst || "",

        email:
          res.data.email || "",

        mobile:
          res.data.mobile || "",

        address:
          res.data.address || "",

        state:
          res.data.state || "",

        type:
          res.data.type || "",

        pin:
          res.data.pin || "",

        description:
          res.data.description || "",
      });

      // =================================================
      // CURRENT PASSWORD
      // =================================================

      setPasswordData({
        currentPassword:
          res.data.pass || "",

        newPassword: "",

        confirmPassword: "",
      });

      // =================================================
      // PROFILE IMAGE
      // =================================================

      if (res.data.image) {
        const imageUrl =
          `https://api.dectwinbilling.com/dUploads/${res.data.image}`;

        setProfileImage(imageUrl);

        setProfilePreview(imageUrl);
      }

      // =================================================
      // SIGNATURE
      // =================================================

      if (res.data.sign) {
        const signUrl =
          `https://api.dectwinbilling.com/dUploads/${res.data.sign}`;

        setSignatureImage(signUrl);
      }

    } catch (error) {
      console.log(
        "Fetch Profile Error:",
        error
      );
    }
  };

  // =====================================================
  // LOAD PROFILE
  // =====================================================

  useEffect(() => {
    fetchProfile();
  }, []);

  // =====================================================
  // SIGNATURE CHANGE
  // =====================================================

  const handleSignatureChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      setSignatureImage(file);

      setSignaturePreview(
        URL.createObjectURL(file)
      );
    }
  };

  // =====================================================
  // CHANGE PASSWORD
  // =====================================================

  const handleChangePassword = async () => {
    try {
      const userData = JSON.parse(
        localStorage.getItem("user_data")
      );

      if (!userData?.id) {
        showError(
          "User information not found"
        );

        return;
      }

      // =================================================
      // CURRENT PASSWORD VALIDATION
      // =================================================

      if (!passwordData.currentPassword) {
        showError(
          "Please enter current password"
        );

        return;
      }

      // =================================================
      // NEW PASSWORD VALIDATION
      // =================================================

      if (!passwordData.newPassword) {
        showError(
          "Please enter new password"
        );

        return;
      }

      // =================================================
      // MINIMUM 6 CHARACTERS
      // =================================================

      if (
        passwordData.newPassword.length < 6
      ) {
        showError(
          "New password must be at least 6 characters"
        );

        return;
      }

      // =================================================
      // CONFIRM PASSWORD
      // =================================================

      if (
        passwordData.newPassword !==
        passwordData.confirmPassword
      ) {
        showError(
          "New password and confirm password do not match"
        );

        return;
      }

      // =================================================
      // CHANGE PASSWORD API
      // =================================================

      const res = await axios.put(
        `https://api.dectwinbilling.com/change-password/${userData.id}`,
        {
          currentPassword:
            passwordData.currentPassword,

          newPassword:
            passwordData.newPassword,
        }
      );

      // =================================================
      // SUCCESS
      // =================================================

      showSuccess(
        res.data?.message ||
        "Password changed successfully"
      );

      // =================================================
      // CLEAR NEW PASSWORDS
      // =================================================

      setPasswordData({
        currentPassword:
          passwordData.currentPassword,

        newPassword: "",

        confirmPassword: "",
      });

      // =================================================
      // CLOSE PASSWORD SECTION
      // =================================================

      setShowPasswordSection(false);

      setShowCurrentPassword(false);

      setShowNewPassword(false);

      setShowConfirmPassword(false);

    } catch (error) {
      console.log(
        "Change Password Error:",
        error
      );

      showError(
        error.response?.data?.message ||
        "Unable to change password"
      );
    }
  };
    // =====================================================
  // OPEN SAVE CONFIRMATION MODAL
  // =====================================================

  const handleSaveProfile = () => {
    setShowSaveModal(true);
  };

  // =====================================================
  // SAVE PROFILE
  // =====================================================

  const saveProfile = async () => {
    // Close confirmation modal
    setShowSaveModal(false);

    try {
      // =================================================
      // USER DATA
      // =================================================

      const userData = JSON.parse(
        localStorage.getItem("user_data")
      );

      if (!userData?.id) {
        showError(
          "User information not found"
        );

        return;
      }

      // =================================================
      // FORM DATA
      // =================================================

      const formData = new FormData();

      // =================================================
      // PROFILE FIELDS
      // =================================================

      formData.append(
        "business_name",
        profileData.business_name
      );

      formData.append(
        "gst",
        profileData.gst
      );

      formData.append(
        "email",
        profileData.email
      );

      formData.append(
        "mobile",
        profileData.mobile
      );

      formData.append(
        "address",
        profileData.address
      );

      formData.append(
        "state",
        profileData.state
      );

      formData.append(
        "type",
        profileData.type
      );

      formData.append(
        "pin",
        profileData.pin
      );

      formData.append(
        "description",
        profileData.description
      );

      // =================================================
      // PROFILE IMAGE
      // =================================================

      if (profileImage instanceof File) {
        formData.append(
          "image",
          profileImage
        );
      }

      // =================================================
      // SIGNATURE
      // =================================================

      if (signatureImage instanceof File) {
        formData.append(
          "sign",
          signatureImage
        );
      }

      // =================================================
      // UPDATE PROFILE API
      // =================================================

      const res = await axios.put(
        `https://api.dectwinbilling.com/update-profile/${userData.id}`,
        formData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      // =================================================
      // FETCH UPDATED PROFILE
      // =================================================

      const latestProfile =
        await axios.get(
          `https://api.dectwinbilling.com/fetchprofile/${userData.id}`
        );

      // =================================================
      // UPDATED USER
      // =================================================

      const updatedUser = {
        ...userData,
        ...profileData,

        image:
          latestProfile.data.image ||
          userData.image,

        sign:
          latestProfile.data.sign ||
          userData.sign,

        imageUpdatedAt:
          Date.now(),
      };

      // =================================================
      // SAVE LOCAL STORAGE
      // =================================================

      localStorage.setItem(
        "user_data",
        JSON.stringify(updatedUser)
      );

      // =================================================
      // UPDATE PARENT STATE
      // =================================================

      setClientData(updatedUser);

      // =================================================
      // SUCCESS
      // =================================================

      showSuccess(
        "Profile Updated Successfully"
      );

      console.log(
        "Updated profile:",
        latestProfile.data
      );

      console.log(
        "Update response:",
        res.data
      );

    } catch (error) {
      console.log(
        "Profile Update Error:",
        error
      );

      showError(
        error.response?.data?.message ||
        "Profile Update Failed"
      );
    }
  };
    return (
    <>
 <style>{`

  /* =====================================================
     GLOBAL
  ===================================================== */
.manage-business-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fb;

  padding: 14px 16px 80px;

  overflow-x: hidden;
  overflow-y: auto;

  position: relative;
}

  .manage-business-page {
    width: 100%;
    min-height: 100vh;
    background: #f5f7fb;
    padding: 14px 16px 30px;
    overflow-x: hidden;
  }

  .manage-business-wrapper {
    width: 100%;
    max-width: 1500px;
    margin: 0 auto;
  }

  /* =====================================================
     HEADER
  ===================================================== */

  .business-header {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 15px;
    margin-bottom: 10px;
  }

  .business-header-left {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    min-width: 0;
  }

  .business-header-icon {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 7px;
    background: #eaf3ff;
    color: #1677ff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
  }

  .business-header h2 {
    margin: 0;
    color: #17243b;
    font-size: 17px;
    font-weight: 800;
    line-height: 1.2;
  }

  .business-header p {
    margin: 3px 0 0;
    color: #7d8798;
    font-size: 9px;
    line-height: 1.4;
  }

  .business-breadcrumb {
    flex-shrink: 0;
    padding-top: 5px;
    font-size: 8px;
    color: #8b95a6;
    white-space: nowrap;
  }

  .business-breadcrumb span:last-child {
    color: #344054;
    font-weight: 700;
  }

  /* =====================================================
     MAIN CARD
  ===================================================== */

  .business-card {
    width: 100%;
    background: #fff;
    border: 1px solid #e3e8ef;
    border-radius: 11px;
    box-shadow: 0 3px 15px rgba(30, 50, 80, .06);
    overflow: hidden;
  }

  /* =====================================================
     PROFILE TOP
  ===================================================== */

  .business-profile-top {
    width: 100%;
    min-height: 82px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 13px 15px;
    border-bottom: 1px solid #edf1f5;
  }

  .business-profile-left {
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
  }

  .business-avatar-wrap {
    position: relative;
    width: 62px;
    height: 62px;
    min-width: 62px;
  }

  .business-avatar {
    width: 62px;
    height: 62px;
    border-radius: 50%;
    object-fit: cover;
    border: 2px solid #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,.16);
  }

  .business-camera-btn {
    position: absolute;
    right: -2px;
    bottom: -1px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 2px solid #fff;
    background: #1677ff;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .business-profile-details {
    margin-left: 12px;
    min-width: 0;
  }

  .business-profile-name {
    margin: 0;
    color: #17243b;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.25;
    overflow-wrap: anywhere;
  }

  .business-active-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: 7px;
    padding: 3px 8px;
    border-radius: 12px;
    background: #e9f9ef;
    color: #149653;
    font-size: 8px;
    font-weight: 800;
    vertical-align: middle;
  }

  .business-profile-label {
    margin: 4px 0 1px;
    font-size: 9px;
    color: #64748b;
  }

  .business-profile-help {
    margin: 0;
    font-size: 8px;
    color: #9aa3b1;
  }

  /* =====================================================
     BUILD BRAND
  ===================================================== */

  .build-brand-btn {
    flex: 0 0 auto;
    width: 205px;
    min-height: 58px;
    border: 1px solid #edf0f4;
    background: linear-gradient(
      135deg,
      #fffdf2,
      #f8f9ff
    );
    border-radius: 8px;
    padding: 9px 11px;
    display: flex;
    align-items: center;
    gap: 9px;
    text-align: left;
    cursor: pointer;
  }

  .build-brand-icon {
    width: 34px;
    height: 34px;
    min-width: 34px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #f5b900;
    font-size: 15px;
    box-shadow: 0 2px 7px rgba(0,0,0,.07);
  }

  .build-brand-title {
    margin: 0;
    font-size: 9px;
    font-weight: 800;
    color: #35435a;
  }

  .build-brand-text {
    margin: 3px 0 0;
    font-size: 7px;
    line-height: 1.4;
    color: #8b95a5;
  }

  /* =====================================================
     BUSINESS INFORMATION
  ===================================================== */

  .business-info-section {
    width: calc(100% - 24px);
    margin: 10px 12px 0;
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    overflow: hidden;
  }

  .business-info-heading {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 9px 11px;
    border-bottom: 1px solid #edf1f5;
  }

  .business-info-heading-icon {
    width: 24px;
    height: 24px;
    min-width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1677ff;
    font-size: 14px;
  }

  .business-info-heading h4 {
    margin: 0;
    font-size: 12px;
    font-weight: 800;
    color: #17243b;
  }

  .business-info-heading p {
    margin: 2px 0 0;
    font-size: 7px;
    color: #8d97a7;
  }

  .business-info-body {
    width: 100%;
    padding: 11px 12px 12px;
  }

  /* =====================================================
     FORM
  ===================================================== */

  .business-field {
    width: 100%;
    margin-bottom: 8px;
  }

  .business-field label {
    display: block;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: 700;
    color: #536074;
    line-height: 1.2;
  }

  .business-field-input-wrap {
    position: relative;
    width: 100%;
  }

.business-field-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 15px;
  color: #66758a;
  z-index: 2;
  pointer-events: none;
}
  .business-field input,
  .business-field select {
    width: 100%;
    min-width: 0;
    height: 34px;
    border: 1px solid #dfe5ec;
    border-radius: 6px;
    background: #fff;
    color: #344054;
    font-size: 9px;
    padding: 6px 9px 6px 27px;
    outline: none;
    box-shadow: none;
  }

  .business-field input::placeholder {
    color: #a1aab8;
  }

  .business-field input:focus,
  .business-field select:focus {
    border-color: #76aaf4;
    box-shadow: 0 0 0 2px rgba(22,119,255,.07);
  }

  /* =====================================================
     UPLOAD
  ===================================================== */

  .business-upload-area {
    width: 100%;
    border-top: 1px solid #edf1f5;
    margin-top: 5px;
    padding-top: 11px;
  }

  .business-upload-heading {
    display: flex;
    align-items: center;
    gap: 7px;
    margin-bottom: 3px;
    font-size: 9px;
    font-weight: 800;
    color: #35435a;
  }

  .business-upload-heading-icon {
    color: #1677ff;
    font-size: 13px;
  }

  .business-upload-description {
    margin: 0 0 8px 20px;
    font-size: 7px;
    color: #969fad;
  }

  .business-upload-grid {
    width: 100%;
    display: grid;
    grid-template-columns:
      minmax(0, 1.15fr)
      minmax(105px, 150px)
      minmax(0, 1fr);
    gap: 9px;
  }

  .business-drop-area {
    width: 100%;
    min-height: 72px;
    border: 1px dashed #cdd6e2;
    border-radius: 7px;
    background: #fbfcfe;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
    padding: 8px;
  }

  .business-drop-icon {
    font-size: 17px;
    color: #9ba5b4;
    margin-bottom: 3px;
  }

  .business-drop-text {
    font-size: 8px;
    font-weight: 700;
    color: #788496;
  }

  .business-drop-small {
    margin-top: 3px;
    font-size: 6px;
    color: #a2abb8;
  }

  .business-current-image {
    width: 100%;
    min-height: 72px;
    border: 1px solid #e3e8ef;
    border-radius: 7px;
    background: #fafbfd;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .business-current-image-label {
    position: absolute;
    top: 5px;
    left: 7px;
    font-size: 6px;
    color: #7d8798;
    font-weight: 700;
  }

  .business-current-image img {
    width: 75px;
    height: 50px;
    object-fit: contain;
    margin-top: 7px;
    border-radius: 3px;
  }

  .business-tips {
    width: 100%;
    min-height: 72px;
    border-radius: 7px;
    background: #eafaf3;
    padding: 9px 11px;
    overflow: hidden;
  }

  .business-tips-title {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 800;
    color: #15935d;
  }

  .business-tips ul {
    margin: 0;
    padding-left: 14px;
  }

  .business-tips li {
    margin-bottom: 2px;
    font-size: 6px;
    line-height: 1.35;
    color: #4c7d68;
  }
    .business-header-icon {
  width: 50px;
  height: 50px;
  min-width: 30px;
  border-radius: 7px;
  background: #eaf3ff;
  color: #ff1616;
  display: flex;
  align-items: center;
  justify-content: center;
}

.business-header-icon .bi {
  font-size: 22px;
}

  /* =====================================================
     ACTIONS
  ===================================================== */

  .business-actions {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 9px 12px;
    border-top: 1px solid #edf1f5;
  }

  .business-reset-btn {
    height: 32px;
    padding: 0 14px;
    border: 1px solid #dfe5ec;
    border-radius: 6px;
    background: #fff;
    color: #687588;
    font-size: 8px;
    font-weight: 700;
    cursor: pointer;
  }

  .business-save-btn {
    height: 34px;
    padding: 0 17px;
    border: 0;
    border-radius: 6px;
    background: var(--primary-color, #1677ff);
    color: #fff;
    font-size: 8px;
    font-weight: 800;
    cursor: pointer;
    box-shadow: 0 3px 7px rgba(22,119,255,.18);
    white-space: nowrap;
  }

  /* =====================================================
     SECURITY
  ===================================================== */

  .business-security-card,
  .business-signature-card {
    width: calc(100% - 24px);
    margin: 10px 12px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    background: #fff;
  }

  .business-security-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
  }

  .business-security-head h5 {
    margin: 0;
    font-size: 12px;
    font-weight: 800;
    color: #17243b;
  }

  .business-security-head p {
    margin: 3px 0 0;
    font-size: 7px;
    color: #8b95a5;
  }

  .business-password-toggle {
    height: 32px;
    padding: 0 14px;
    border: 0;
    border-radius: 6px;
    background: var(--primary-color, #1677ff);
    color: #fff;
    font-size: 8px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
  }

  .business-password-form {
    width: 100%;
    max-width: 700px;
    margin-top: 11px;
    padding: 12px;
    border-radius: 7px;
    background: #f8fafc;
    border: 1px solid #e7ecf2;
  }

  .business-password-form h6 {
    margin: 0 0 10px;
    font-size: 10px;
    font-weight: 800;
  }

  .business-password-form .form-label {
    font-size: 8px;
    margin-bottom: 4px;
  }

  .business-password-form .form-control {
    width: 100%;
    height: 34px;
    border-radius: 6px !important;
    font-size: 9px;
  }

  /* =====================================================
     SIGNATURE
  ===================================================== */

  .business-signature-card {
    margin-bottom: 20px;
  }

  .business-signature-card h5 {
    margin: 0 0 8px;
    font-size: 12px;
    font-weight: 800;
    color: #17243b;
  }

  .business-signature-preview {
    width: 100%;
    max-width: 500px;
    height: 85px;
    border: 1px dashed #d4dce7;
    border-radius: 7px;
    background: #fafbfd;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    margin-bottom: 8px;
  }

  .business-signature-preview img {
    max-width: 100%;
    max-height: 75px;
    object-fit: contain;
  }

  .business-signature-preview span {
    font-size: 8px;
    color: #9ba4b2;
  }

  .business-signature-card input[type="file"] {
    width: 100%;
    max-width: 500px;
    height: 34px;
    font-size: 8px;
  }

  /* =====================================================
     MODAL
  ===================================================== */

.business-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;

  background: rgba(15, 23, 42, 0.45);

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 15px;
}

.business-modal {
  width: 100%;
  max-width: 400px;

  background: #fff;
  border-radius: 10px;

  padding: 18px;

  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.20);
}

.business-modal h5 {
  margin: 0 0 5px;

  font-size: 15px;
  font-weight: 800;
  line-height: 1.3;

  color: #17243b;
}

.business-modal p {
  margin: 0 0 14px;

  font-size: 9px;
  line-height: 1.5;

  color: #7b8797;
}

/* Modal button row */
.business-modal .modal-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 8px;

  width: 100%;
}

/* Both modal buttons */
.business-modal .modal-actions button {
  height: 34px !important;

  min-width: 72px !important;

  padding: 0 14px !important;

  border-radius: 6px !important;

  font-size: 8px !important;
  font-weight: 700 !important;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  white-space: nowrap;

  cursor: pointer;
}

/* Cancel */
.business-modal .modal-cancel-btn {
  border: 1px solid #98a2b3 !important;

  background: #fff !important;
  color: #475467 !important;
}

.business-modal .modal-cancel-btn:hover {
  background: #f8fafc !important;
}

/* Yes Save */
.business-modal .modal-save-btn {
  border: 0 !important;

  background: var(--primary-color, #ff6b5f) !important;
  color: #fff !important;

  box-shadow: 0 3px 8px rgba(255, 107, 95, 0.22);
}

.business-modal .modal-save-btn:hover {
  filter: brightness(0.96);
}

/* =========================================================
   MOBILE MODAL
   ========================================================= */

@media (max-width: 767px) {

  .business-modal-overlay {
    padding: 12px;
  }

  .business-modal {
    width: 100%;
    max-width: 340px;

    padding: 16px;

    border-radius: 10px;
  }

  .business-modal h5 {
    font-size: 14px;
  }

  .business-modal p {
    font-size: 8px;
    margin-bottom: 13px;
  }

  .business-modal .modal-actions {
    gap: 7px;
  }

  .business-modal .modal-actions button {
    height: 33px !important;

    min-width: 70px !important;

    padding: 0 13px !important;

    font-size: 8px !important;
  }
}

/* Small mobile */
@media (max-width: 430px) {

  .business-modal {
    max-width: calc(100% - 20px);
    padding: 15px;
  }

  .business-modal .modal-actions button {
    min-width: 68px !important;
    height: 32px !important;
  }
}

  /* =====================================================
     TABLET
  ===================================================== */

  @media (max-width: 991px) {

    .business-upload-grid {
      grid-template-columns:
        minmax(0, 1fr)
        minmax(110px, 145px);
    }

    .business-tips {
      grid-column: 1 / -1;
    }

  }

  /* =====================================================
     MOBILE
  ===================================================== */

  @media (max-width: 767px) {

    .manage-business-page {
      padding: 10px 8px 80px;
    }

    .business-header {
      align-items: flex-start;
      margin-bottom: 8px;
    }

    .business-header h2 {
      font-size: 15px;
    }

    .business-header p {
      font-size: 8px;
    }

    .business-header-icon {
      width: 27px;
      height: 27px;
      min-width: 27px;
      font-size: 13px;
    }

    .business-breadcrumb {
      display: none;
    }

    .business-profile-top {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
      padding: 11px;
    }

    .business-profile-name {
      font-size: 14px;
    }

    .business-profile-label {
      font-size: 8px;
    }

    .business-profile-help {
      font-size: 7px;
    }

    .build-brand-btn {
      width: 100%;
      max-width: none;
    }

    .business-info-section,
    .business-security-card,
    .business-signature-card {
      width: calc(100% - 14px);
      margin-left: 7px;
      margin-right: 7px;
    }

    .business-info-body {
      padding: 9px;
    }

    .business-field label {
      font-size: 8px;
    }

    .business-field input,
    .business-field select {
      height: 36px;
      font-size: 9px;
    }

    .business-upload-grid {
      grid-template-columns: 1fr;
    }

    .business-drop-area,
    .business-current-image,
    .business-tips {
      min-height: 75px;
    }

    .business-actions {
      padding: 9px;
    }

    .business-security-head {
      align-items: flex-start;
    }

  }

  /* =====================================================
     SMALL MOBILE
  ===================================================== */

  @media (max-width: 430px) {

    .business-profile-left {
      align-items: flex-start;
    }

    .business-avatar-wrap,
    .business-avatar {
      width: 52px;
      height: 52px;
      min-width: 52px;
    }

    .business-profile-name {
      font-size: 13px;
    }

    .business-active-badge {
      font-size: 7px;
      padding: 2px 6px;
    }

    .business-security-head {
      flex-direction: column;
      align-items: stretch;
    }

    .business-password-toggle {
      width: 100%;
    }

    .business-actions {
      flex-direction: row;
    }

    .business-reset-btn,
    .business-save-btn {
      flex: 1;
    }

  }
    .business-header-left {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.add-branch-btn {
  height: 30px;
  padding: 0 12px;
  margin-left: 8px;
  border: 0;
  border-radius: 6px;
  background: var(--primary-color, #1677ff);
  color: #fff;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;

  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;

  box-shadow: 0 3px 8px rgba(22,119,255,.18);
}

.add-branch-btn:hover {
  filter: brightness(.95);
}

.add-branch-btn .bi {
  font-size: 10px;
}
  @media (max-width: 767px) {
  .business-header-left {
    flex-wrap: wrap;
    gap: 7px;
  }

  .add-branch-btn {
    margin-left: 0;
    height: 28px;
    padding: 0 10px;
    font-size: 7px;
  }
}
    .business-field-input-wrap {
  position: relative;
  width: 100%;
}

.business-field-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);

  width: 18px;
  height: 18px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #66758a;
  z-index: 2;
  pointer-events: none;
}

.business-field-icon svg {
  width: 16px;
  height: 16px;
  display: block;
}

.business-field input,
.business-field select {
  width: 100%;
  padding: 6px 9px 6px 34px;
}
  /* =========================================================
   FINAL BOTTOM OVERLAP FIX
   ========================================================= */

.manage-business-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fb;

  /* bottom navigation ke liye extra scroll space */
  padding: 14px 16px 110px !important;

  overflow-x: hidden;
  overflow-y: auto;

  position: relative;
  box-sizing: border-box;
}

/* Main content wrapper */
.manage-business-wrapper {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding-bottom: 20px;
}

/* Business information */
.business-info-section {
  position: relative;
  z-index: 1;
  margin-bottom: 10px;
}

/* Security */
.business-security-card {
  position: relative;
  z-index: 1;
  width: calc(100% - 24px);
  margin: 10px 12px;
  padding: 12px;
  box-sizing: border-box;
}

/* Signature */
.business-signature-card {
  position: relative;
  z-index: 1;

  width: calc(100% - 24px);
  margin: 10px 12px 70px;

  padding: 12px;

  box-sizing: border-box;
}

/* Signature preview */
.business-signature-preview {
  width: 100%;
  max-width: 500px;
  height: 85px;

  margin-bottom: 8px;

  overflow: hidden;
}

/* File input */
.business-signature-card input[type="file"] {
  width: 100%;
  max-width: 500px;
  height: 34px;
}

/* =========================================================
   MOBILE
   ========================================================= */

@media (max-width: 767px) {

  .manage-business-page {
    width: 100%;
    min-height: 100vh;

    padding: 10px 8px 125px !important;

    overflow-x: hidden;
    overflow-y: auto;

    -webkit-overflow-scrolling: touch;
  }

  .manage-business-wrapper {
    width: 100%;
    padding-bottom: 25px;
  }

  .business-info-section,
  .business-security-card,
  .business-signature-card {
    width: calc(100% - 14px);
    margin-left: 7px;
    margin-right: 7px;
  }

  /* Business info */
  .business-info-section {
    margin-top: 8px;
    margin-bottom: 10px;
  }

  /* Security */
  .business-security-card {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Signature */
  .business-signature-card {
    margin-top: 10px;

    /* fixed bottom nav se safe distance */
    margin-bottom: 45px;
  }

  /* Last card ke neeche extra space */
  .business-signature-card::after {
    content: "";
    display: block;
    height: 20px;
  }

  /* Action buttons */
  .business-actions {
    position: relative;
    z-index: 2;
  }

  /* Form icons */
  .business-field-icon {
    position: absolute;
    left: 10px;
    top: 50%;

    width: 18px;
    height: 18px;

    transform: translateY(-50%);

    display: flex;
    align-items: center;
    justify-content: center;

    color: #66758a;

    z-index: 2;
    pointer-events: none;
  }

  .business-field-icon svg {
    width: 16px;
    height: 16px;
    display: block;
  }

  .business-field input,
  .business-field select {
    width: 100%;
    min-width: 0;

    padding: 6px 34px 6px 34px;
    box-sizing: border-box;
  }

  /* Upload area */
  .business-upload-area {
    width: 100%;
  }

  .business-upload-grid {
    width: 100%;
    grid-template-columns: 1fr;
  }

  .business-drop-area,
  .business-current-image,
  .business-tips {
    width: 100%;
    min-height: 75px;
  }
}

/* =========================================================
   SMALL MOBILE
   ========================================================= */

@media (max-width: 430px) {

  .manage-business-page {
    padding: 10px 6px 130px !important;
  }

  .manage-business-wrapper {
    padding-bottom: 30px;
  }

  .business-info-section,
  .business-security-card,
  .business-signature-card {
    width: calc(100% - 10px);
    margin-left: 5px;
    margin-right: 5px;
  }

  .business-security-card {
    margin-top: 9px;
    margin-bottom: 9px;
  }

  .business-signature-card {
    margin-top: 9px;
    margin-bottom: 50px;
  }

  .business-signature-preview {
    height: 85px;
  }

  .business-signature-card input[type="file"] {
    width: 100%;
    height: 34px;
  }
}

/* =========================================================
   VERY SMALL SCREEN
   ========================================================= */

@media (max-width: 360px) {

  .manage-business-page {
    padding-left: 5px !important;
    padding-right: 5px !important;
    padding-bottom: 135px !important;
  }

  .business-info-section,
  .business-security-card,
  .business-signature-card {
    width: calc(100% - 8px);
    margin-left: 4px;
    margin-right: 4px;
  }

  .business-signature-card {
    margin-bottom: 55px;
  }
}
  @media (max-width: 767px) {

  /* Save Changes button */
  .business-save-btn {
    width: auto !important;
    min-width: 105px !important;
    max-width: 125px !important;
    padding: 0 12px !important;
    margin-left: auto;
  }

  /* Change Password button */
  .business-password-toggle {
    width: auto !important;
    min-width: 105px !important;
    max-width: 125px !important;
    padding: 0 12px !important;
    margin-left: auto;
  }

}

`}</style>

      <div className="manage-business-page">

        <div className="manage-business-wrapper">

          {/* =================================================
              PAGE HEADER
          ================================================= */}

          <div className="business-header">
            

            {/* <div className="business-header-left">

      <div className="business-header-icon">
  <i className="bi bi-shop"></i>
</div>

              <div>
                <h2>
                  Manage Business
                </h2>

                <p>
                  Keep your business details up to date
                  for invoices, reports and compliance.
                </p>
              </div>

            </div> */}
<div className="business-header">

  <div className="business-header-left">

    <div className="business-header-icon">
      <i className="bi bi-shop"></i>
    </div>

    <div>
      <h2>Manage Business</h2>

      <p>
        Keep your business details up to date
        for invoices, reports and compliance.
      </p>
    </div>

    {/* ADD BRANCH */}
    <button
      type="button"
      className="add-branch-btn"
      onClick={() => navigate("/branch")}
    >
      <i className="bi bi-plus-lg"></i>
      Add Branch
    </button>

  </div>

  <div className="business-breadcrumb">
    <span>Home</span>
    <span className="mx-1">›</span>
    <span>Manage Business</span>
  </div>

</div>
            <div className="business-breadcrumb">
              <span>Home</span>
              <span className="mx-1">›</span>
              <span>
                Manage Business
              </span>
            </div>

          </div>

          {/* =================================================
              MAIN CARD
          ================================================= */}

          <div className="business-card">

            {/* =================================================
                PROFILE HEADER
            ================================================= */}

            <div className="business-profile-top">

              <div className="business-profile-left">

                <div className="business-avatar-wrap">

                  <img
                    src={profilePreview}
                    alt="Business Profile"
                    className="business-avatar"
                  />

                  <label
                    htmlFor="profile-upload"
                    className="business-camera-btn"
                  >
                    <FaCamera size={8} />
                  </label>

                  <input
                    id="profile-upload"
                    type="file"
                    accept="image/*"
                    style={{
                      display: "none",
                    }}
                    onChange={
                      handleProfileChange
                    }
                  />

                </div>

                <div className="business-profile-details">

                  <h3 className="business-profile-name">

                    {profileData.business_name ||
                      "Dectwin"}

                    <span className="business-active-badge">
                      ● Active
                    </span>

                  </h3>

                  <p className="business-profile-label">
                    Business Profile
                  </p>

                  <p className="business-profile-help">
                    Update your business information and logo
                  </p>

                </div>

              </div>

              {/* BUILD BRAND */}

              <button
                type="button"
                className="build-brand-btn"
                onClick={() =>
                  navigate("/branch")
                }
              >

                <div className="build-brand-icon">
                  👑
                </div>

                <div>

                  <p className="build-brand-title">
                    Build Your Brand
                  </p>

                  <p className="build-brand-text">
                    A professional profile builds
                    trust with your customers.
                  </p>

                </div>

              </button>

            </div>

            {/* =================================================
                BUSINESS INFORMATION
            ================================================= */}

            <div className="business-info-section">

              <div className="business-info-heading">

                <div className="business-info-heading-icon">
                  🏢
                </div>

                <div>

                  <h4>
                    Business Information
                  </h4>

                  <p>
                    This information will be used in invoices,
                    reports and other documents.
                  </p>

                </div>

              </div>

             <div className="business-info-body">
  <div className="row g-2">

    {/* FULL NAME */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>
          Full Name <span className="text-danger">*</span>
        </label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaUser />
          </span>

          <input
            type="text"
            placeholder="Enter Name"
            value={profileData.business_name}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                business_name: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

    {/* GSTIN */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>GSTIN</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaIdCard />
          </span>

          <input
            type="text"
            placeholder="Enter GSTIN"
            value={profileData.gst}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                gst: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

    {/* EMAIL */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>Email</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaEnvelope />
          </span>

          <input
            type="text"
            placeholder="Enter Email"
            value={profileData.email}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                email: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

    {/* MOBILE */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>Mobile Number</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaPhone />
          </span>

          <input
            type="text"
            placeholder="Enter mobile"
            value={profileData.mobile}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                mobile: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

    {/* ADDRESS */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>Address</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaMapMarkerAlt />
          </span>

          <input
            type="text"
            placeholder="Enter Address"
            value={profileData.address}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                address: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

    {/* STATE */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>State</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaMapMarkerAlt />
          </span>

          <select
            value={profileData.state}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                state: e.target.value,
              })
            }
          >
            <option value="">Select State</option>
            <option value="Andhra Pradesh">Andhra Pradesh</option>
            <option value="Arunachal Pradesh">Arunachal Pradesh</option>
            <option value="Assam">Assam</option>
            <option value="Bihar">Bihar</option>
            <option value="Chhattisgarh">Chhattisgarh</option>
            <option value="Delhi">Delhi</option>
            <option value="Goa">Goa</option>
            <option value="Gujarat">Gujarat</option>
            <option value="Haryana">Haryana</option>
            <option value="Himachal Pradesh">Himachal Pradesh</option>
            <option value="Jharkhand">Jharkhand</option>
            <option value="Karnataka">Karnataka</option>
            <option value="Kerala">Kerala</option>
            <option value="Madhya Pradesh">Madhya Pradesh</option>
            <option value="Maharashtra">Maharashtra</option>
            <option value="Manipur">Manipur</option>
            <option value="Meghalaya">Meghalaya</option>
            <option value="Mizoram">Mizoram</option>
            <option value="Nagaland">Nagaland</option>
            <option value="Odisha">Odisha</option>
            <option value="Punjab">Punjab</option>
            <option value="Rajasthan">Rajasthan</option>
            <option value="Sikkim">Sikkim</option>
            <option value="Tamil Nadu">Tamil Nadu</option>
            <option value="Telangana">Telangana</option>
            <option value="Tripura">Tripura</option>
            <option value="Uttar Pradesh">Uttar Pradesh</option>
            <option value="Uttarakhand">Uttarakhand</option>
            <option value="West Bengal">West Bengal</option>
          </select>
        </div>
      </div>
    </div>

    {/* BUSINESS TYPE */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>Business Type</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaBriefcase />
          </span>

          <select
            value={profileData.type}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                type: e.target.value,
              })
            }
          >
            <option value="">Select Business Type</option>
            <option value="Service">Service</option>
            <option value="Wholeseller">Wholeseller</option>
            <option value="Retail">Retail</option>
          </select>
        </div>
      </div>
    </div>

    {/* PINCODE */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>Area Pincode</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaMapPin />
          </span>

          <input
            type="text"
            placeholder="Enter Area Pincode"
            value={profileData.pin}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                pin: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

    {/* DESCRIPTION */}
    <div className="col-12 col-md-4">
      <div className="business-field">
        <label>Description</label>

        <div className="business-field-input-wrap">
          <span className="business-field-icon">
            <FaAlignLeft />
          </span>

          <input
            type="text"
            placeholder="Enter Description"
            value={profileData.description}
            onChange={(e) =>
              setProfileData({
                ...profileData,
                description: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>

  </div>
</div>

              {/* =================================================
                  ACTION BUTTONS
              ================================================= */}

              <div className="business-actions">


                <button
                  type="button"
                  className="business-save-btn"
                  onClick={handleSaveProfile}
                >
                  ✓ &nbsp; Save Changes
                </button>

              </div>

            </div>

          </div>
                    {/* =================================================
              SECURITY
          ================================================= */}

          <div className="business-security-card">

            <div className="business-security-head">

              <div>
                <h5>
                  Security
                </h5>

                <p>
                  Manage your account password and security.
                </p>
              </div>

              <button
                type="button"
                className="business-password-toggle"
                onClick={() =>
                  setShowPasswordSection(
                    !showPasswordSection
                  )
                }
              >
                {showPasswordSection
                  ? "Cancel"
                  : "Change Password"}
              </button>

            </div>

            {showPasswordSection && (
              <div className="business-password-form">

                <h6>
                  Change Password
                </h6>

                {/* CURRENT PASSWORD */}

                <div className="mb-2">

                  <label className="form-label fw-semibold">
                    Current Password
                  </label>

                  <div className="position-relative">

                    <input
                      type={
                        showCurrentPassword
                          ? "text"
                          : "password"
                      }
                      className="form-control pe-5"
                      value={
                        passwordData.currentPassword
                      }
                      onChange={(e) =>
                        setPasswordData({
                          ...passwordData,
                          currentPassword:
                            e.target.value,
                        })
                      }
                    />

                    <button
                      type="button"
                      className="position-absolute top-50 end-0 translate-middle-y me-2 border-0 bg-transparent"
                      onClick={() =>
                        setShowCurrentPassword(
                          !showCurrentPassword
                        )
                      }
                    >
                      {showCurrentPassword ? (
                        <EyeOff size={13} />
                      ) : (
                        <Eye size={13} />
                      )}
                    </button>

                  </div>

                </div>

                {/* NEW PASSWORD */}

                <div className="mb-2">

                  <label className="form-label fw-semibold">
                    New Password
                  </label>

                  <div className="position-relative">

                    <input
                      type={
                        showNewPassword
                          ? "text"
                          : "password"
                      }
                      className="form-control pe-5"
                      placeholder="Enter new password"
                      value={
                        passwordData.newPassword
                      }
                      onChange={(e) =>
                        setPasswordData({
                          ...passwordData,
                          newPassword:
                            e.target.value,
                        })
                      }
                    />

                    <button
                      type="button"
                      className="position-absolute top-50 end-0 translate-middle-y me-2 border-0 bg-transparent"
                      onClick={() =>
                        setShowNewPassword(
                          !showNewPassword
                        )
                      }
                    >
                      {showNewPassword ? (
                        <EyeOff size={13} />
                      ) : (
                        <Eye size={13} />
                      )}
                    </button>

                  </div>

                </div>

                {/* CONFIRM PASSWORD */}

                <div className="mb-3">

                  <label className="form-label fw-semibold">
                    Confirm New Password
                  </label>

                  <div className="position-relative">

                    <input
                      type={
                        showConfirmPassword
                          ? "text"
                          : "password"
                      }
                      className="form-control pe-5"
                      placeholder="Confirm new password"
                      value={
                        passwordData.confirmPassword
                      }
                      onChange={(e) =>
                        setPasswordData({
                          ...passwordData,
                          confirmPassword:
                            e.target.value,
                        })
                      }
                    />

                    <button
                      type="button"
                      className="position-absolute top-50 end-0 translate-middle-y me-2 border-0 bg-transparent"
                      onClick={() =>
                        setShowConfirmPassword(
                          !showConfirmPassword
                        )
                      }
                    >
                      {showConfirmPassword ? (
                        <EyeOff size={13} />
                      ) : (
                        <Eye size={13} />
                      )}
                    </button>

                  </div>

                </div>

                {/* PASSWORD ACTIONS */}

                <div className="d-flex gap-2 flex-wrap">

                  <button
                    type="button"
                    className="business-password-toggle"
                    onClick={
                      handleChangePassword
                    }
                  >
                    Update Password
                  </button>

                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    style={{
                      height: "25px",
                      padding: "0 11px",
                      borderRadius: "5px",
                      fontSize: "6px",
                    }}
                    onClick={() => {

                      setPasswordData({
                        currentPassword:
                          passwordData.currentPassword,
                        newPassword: "",
                        confirmPassword: "",
                      });

                      setShowPasswordSection(
                        false
                      );

                      setShowCurrentPassword(
                        false
                      );

                      setShowNewPassword(
                        false
                      );

                      setShowConfirmPassword(
                        false
                      );

                    }}
                  >
                    Cancel
                  </button>

                </div>

              </div>
            )}

          </div>

          {/* =================================================
              SIGNATURE
          ================================================= */}

          <div className="business-signature-card">

            <h5>
              Signature
            </h5>

            <div className="business-signature-preview">

              {(
                signaturePreview ||
                signatureImage
              ) ? (

                <img
                  src={
                    signaturePreview ||
                    signatureImage
                  }
                  alt="Business Signature"
                />

              ) : (

                <span>
                  No Signature Uploaded
                </span>

              )}

            </div>

            <input
              type="file"
              accept="image/*"
              className="form-control"
              onChange={
                handleSignatureChange
              }
            />

          </div>

        </div>

      </div>

      {/* =====================================================
          SAVE CONFIRMATION MODAL
      ===================================================== */}

      {showSaveModal && (
        <div className="business-modal-overlay">

          <div className="business-modal">

            <h5>
              Save Changes
            </h5>

            <p>
              Are you sure you want to save
              your business profile changes?
            </p>

            {/* <div className="d-flex justify-content-end gap-2">

              <button
                type="button"
                className="btn btn-outline-secondary"
                style={{
                  height: "27px",
                  padding: "0 12px",
                  borderRadius: "5px",
                  fontSize: "6px",
                  fontWeight: 700,
                }}
                onClick={() =>
                  setShowSaveModal(false)
                }
              >
                Cancel
              </button>

              <button
                type="button"
                className="business-save-btn"
                onClick={saveProfile}
              >
                Yes, Save
              </button>

            </div> */}
<div className="modal-actions">

  <button
    type="button"
    className="modal-cancel-btn"
    onClick={() => setShowSaveModal(false)}
  >
    Cancel
  </button>

  <button
    type="button"
    className="modal-save-btn"
    onClick={saveProfile}
  >
    Yes, Save
  </button>

</div>
          </div>

        </div>
      )}

    </>
  );
};

export default Profile;